import { createZustandShallowStore } from '@/lib/zustand';
import { SetStoreState, storeStateResolver } from '@/types/use';

export interface LayoutStoreProps {
    /**
     * cũ | mới
     */
    version: 'legacy' | 'modern';
    setVersion: (ver: 'legacy' | 'modern') => void;

    progress: number;
    setProgress: SetStoreState<number>;

    /**Loading when navigate between pages */
    isLoadingPage: boolean;
    setLoadingPage: SetStoreState<boolean>;
}

export const useLayoutStore = createZustandShallowStore<LayoutStoreProps>(
    (set, get) => ({
        // version: getLayoutStorage(),

        version: 'legacy',

        setVersion(ver) {
            set((st) => ({
                version: ver,
                progress: st.version !== ver ? 0 : -1, // Nếu layout đổi ==> Hiện loader version
            }));
        },

        progress: -1,
        setProgress(fn) {
            set((st) => ({
                progress: storeStateResolver(st.progress, fn),
            }));
        },

        isLoadingPage: false,
        setLoadingPage: (fn) => {
            set((st) => ({
                isLoadingPage: storeStateResolver(st.isLoadingPage, fn),
            }));
        },
    })
);
